export const appConfig = {
  SCHEMA_VERSION: "c29",
};
